import { makeStyles } from '@material-ui/core/styles';

import { COLORS, CSS_CLASS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'row',
      flexFlow: 'row nowrap',
      alignItems: 'center',

      transitionProperty: (props) => (props.transition ? 'background-color' : 'unset'),
      transitionDuration: (props) => (props.transition ? '6s' : 'unset'),

      '&$isDraft': {
        alignItems: 'unset !important',
        padding: theme.spacing(2, 3, 2, 3),
      },

      '&$highlighted': {
        backgroundColor: COLORS.primary.silver,
      },

      border: theme.shape.borderGray60,
      padding: theme.spacing(3, 3, 4, 3),

      // CSS hovered state
      '&$selected': {
        backgroundColor: COLORS.gray.background,
        transitionProperty: 'unset',
        transitionDuration: 'unset',

        '&$detailsAllowed': {
          backgroundColor: COLORS.gray.background,

          '& $score': {
            backgroundColor: COLORS.gray.background,
          },
        },

        '&:not($empty) $textCounter': {
          opacity: '1',
        },
      },

      '&$counterInvalid:not($displayActions)': {
        padding: theme.spacing(2, 3, 4, 3),

        '& $textCounter': {
          opacity: '1',
          bottom: 10,
        },
      },

      '&$displayEditorActions': {
        padding: theme.spacing(2, 3, 10, 3),

        '&$isImageTool': {
          paddingBottom: theme.spacing(7.5),
        },

        '& $textCounter': {
          opacity: '1',
          zIndex: 1000,
          top: 'unset',
          bottom: 58,
        },
      },

      '&$displayActions': {
        '& $actions': {
          opacity: 1,
          transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.short,
          }),
          pointerEvents: 'auto',
        },
      },

      '&$detailsAllowed:not($isImageTool)': {
        cursor: 'pointer',

        '& $score': {
          marginRight: theme.spacing(-1),
        },
      },

      '&$extraHeight': {
        minHeight: 102,
      },

      '&$withStatusHeight': {
        minHeight: 112,
      },

      '&$withStatusHeightLocked': {
        minHeight: 132,
      },
    },
    editing: {},
    selected: {},
    empty: {},
    displayScore: {},
    displayActions: {},
    displayEditorActions: {},
    detailsAllowed: {},
    isImageTool: {},

    textCounter: {
      position: 'absolute',
      bottom: 24,
      opacity: '0',
    },
    editorWrapper: {
      position: 'relative',
      border: '1px solid transparent',
      width: '100%',
      display: 'flex',
      justifyContent: 'start',
      alignItems: 'start',
    },
    editor: {
      justifyContent: 'center',
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(24),
      wordBreak: 'break-word',
    },
    editable: {
      cursor: 'text',
    },

    score: {
      height: '100%',
      flexShrink: '0',
      marginLeft: theme.spacing(2),
      backgroundColor: 'transparent',
    },
    lockedButtons: {
      marginRight: theme.spacing(-1.75),
      marginLeft: theme.spacing(3),
      position: 'relative',
    },
    leftActions: {
      display: 'flex',
      alignItems: 'center',
      flexShrink: '0',
    },
    actions: {
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      bottom: theme.spacing(1.5),
      left: theme.spacing(3),

      opacity: 0,
      pointerEvents: 'none',
    },
    fullWidthActions: {
      right: theme.spacing(3),
    },
    variationContent: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },
    errorTooltip: {
      marginBottom: '5px',
    },
    labelSaved: {
      fontSize: theme.typography.pxToRem(14),
      color: theme.palette.secondary.main,
      width: '75px',
    },
    description: {
      fontSize: theme.typography.pxToRem(12),
      color: COLORS.gray.gray40,
    },
    noScoreActions: {
      height: 'max-content',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      rowGap: theme.spacing(0.75),

      [`&$expanded, .${CSS_CLASS.scoreHoverableParent}:hover &`]: {
        '& $insightsButton': {
          opacity: 1,
          fontSize: theme.typography.pxToRem(12),
          transform: `translateY(${theme.spacing(4)}px)`,
        },
        '& $divider': {
          opacity: 1,
        },
      },
    },
    expanded: {},
    selectGenerationTool: {
      justifyContent: 'flex-end',
    },
    selectGenerationToolButton: {
      fontSize: theme.typography.pxToRem(11),
      lineHeight: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightSemiBold,
    },
    divider: {
      backgroundColor: COLORS.gray.gray70,
      width: '100%',
      opacity: 0,
    },
    insightsButton: {
      position: 'absolute',
      minWidth: 'auto',
      height: 'auto',
      marginLeft: theme.spacing(0.5),
      padding: theme.spacing(0),
      fontSize: theme.typography.pxToRem(11),
      lineHeight: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightSemiBold,
      color: COLORS.primary.default,
      whiteSpace: 'nowrap',

      opacity: 0,
      transform: 'translateY(0px)',
      transition: theme.transitions.create(['opacity', 'transform'], {
        duration: theme.transitions.duration.short,
      }),
    },
    skeleton: {
      width: 35,
      height: 35,
      marginRight: theme.spacing(-1),
    },
    toolBadge: {
      width: 20,
      height: 20,
      position: 'absolute',
      right: 7,
      top: 16,
      background: 'white',
      borderRadius: '50%',
    },
    error: {},
    extraRightPadding: {},
    extraHeight: {},
    withStatusHeight: {},
    withStatusHeightLocked: {},
    isDraft: {},
    highlighted: {},
    notHighlighted: {},

    imageVariationContent: {
      marginRight: theme.spacing(-1), // we do this to align scores in "text" and "image" variations
    },
    counterInvalid: {},

    originalTag: {
      marginRight: theme.spacing(1),
    },
    descriptionWrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
    },
    bullet: {
      ...theme.typography.regular12,
      color: COLORS.gray.gray50,
    },
  }),
  { name: 'Variation' }
);
